import { fromJS } from 'immutable'
import {
  FETCH_VEHICLE_SNAPSHOTS,
  VEHICLE_SNAPSHOTS_RECEIVED,
  VEHICLE_SNAPSHOTS_FAILED,
  CREATE_VEHICLE_SNAPSHOT,
  VEHICLE_SNAPSHOT_CREATED,
  VEHICLE_SNAPSHOT_CREATE_FAILED,
  DELETE_VEHICLE_SNAPSHOT,
  VEHICLE_SNAPSHOT_DELETED,
  VEHICLE_SNAPSHOT_DELETE_FAILED,
  FETCH_VEHICLE_AS_BUILT,
  VEHICLE_AS_BUILT_RECEIVED,
  VEHICLE_AS_BUILT_FAILED,
} from 'actions/vehicleSnapshots'
import { createReducer } from './utils'

export const initialState = fromJS({ bySerialNumber: {} })

const handlers = {
  [FETCH_VEHICLE_SNAPSHOTS]: (state, { payload: { serialNumber } }) =>
    state
      .setIn(['bySerialNumber', serialNumber, 'loading'], true)
      .setIn(['bySerialNumber', serialNumber, 'error'], null),

  [VEHICLE_SNAPSHOTS_RECEIVED]: (
    state,
    { payload: { serialNumber, snapshots } }
  ) =>
    state
      .setIn(['bySerialNumber', serialNumber, 'list'], fromJS(snapshots))
      .setIn(['bySerialNumber', serialNumber, 'loading'], false)
      .setIn(['bySerialNumber', serialNumber, 'error'], null),

  [VEHICLE_SNAPSHOTS_FAILED]: (state, { payload: { serialNumber, error } }) =>
    state
      .setIn(['bySerialNumber', serialNumber, 'loading'], false)
      .setIn(['bySerialNumber', serialNumber, 'error'], error),

  [CREATE_VEHICLE_SNAPSHOT]: (state, { payload: { serialNumber } }) =>
    state
      .setIn(['bySerialNumber', serialNumber, 'saving'], true)
      .setIn(['bySerialNumber', serialNumber, 'error'], null),

  [VEHICLE_SNAPSHOT_CREATED]: (
    state,
    { payload: { serialNumber, snapshot } }
  ) => {
    const current =
      state.getIn(['bySerialNumber', serialNumber, 'list']) || fromJS([])
    return state
      .setIn(
        ['bySerialNumber', serialNumber, 'list'],
        fromJS([snapshot]).concat(current)
      )
      .setIn(['bySerialNumber', serialNumber, 'saving'], false)
      .setIn(['bySerialNumber', serialNumber, 'error'], null)
  },

  [VEHICLE_SNAPSHOT_CREATE_FAILED]: (
    state,
    { payload: { serialNumber, error } }
  ) =>
    state
      .setIn(['bySerialNumber', serialNumber, 'saving'], false)
      .setIn(['bySerialNumber', serialNumber, 'error'], error),

  [DELETE_VEHICLE_SNAPSHOT]: (
    state,
    { payload: { serialNumber, snapshotId } }
  ) => {
    const current =
      state.getIn(['bySerialNumber', serialNumber, 'deletingIds']) || fromJS([])
    return state.setIn(
      ['bySerialNumber', serialNumber, 'deletingIds'],
      current.push(snapshotId)
    )
  },

  [VEHICLE_SNAPSHOT_DELETED]: (
    state,
    { payload: { serialNumber, snapshotId } }
  ) => {
    const currentList =
      state.getIn(['bySerialNumber', serialNumber, 'list']) || fromJS([])
    const currentDeleting =
      state.getIn(['bySerialNumber', serialNumber, 'deletingIds']) || fromJS([])
    return state
      .setIn(
        ['bySerialNumber', serialNumber, 'list'],
        currentList.filter((s) => s.get('id') !== snapshotId)
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'deletingIds'],
        currentDeleting.filter((id) => id !== snapshotId)
      )
      .setIn(['bySerialNumber', serialNumber, 'error'], null)
  },

  [VEHICLE_SNAPSHOT_DELETE_FAILED]: (
    state,
    { payload: { serialNumber, snapshotId, error } }
  ) => {
    const currentDeleting =
      state.getIn(['bySerialNumber', serialNumber, 'deletingIds']) || fromJS([])
    return state.setIn(['bySerialNumber', serialNumber, 'error'], error).setIn(
      ['bySerialNumber', serialNumber, 'deletingIds'],
      currentDeleting.filter((id) => id !== snapshotId)
    )
  },

  [FETCH_VEHICLE_AS_BUILT]: (state, { payload: { serialNumber } }) =>
    state
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'loading'], true)
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'error'], null)
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'features'],
        fromJS([])
      )
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'buildDate'], null)
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'pto'], fromJS(null))
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'pneumatics'],
        fromJS(null)
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'switchAndGauge'],
        fromJS(null)
      )
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'dashboardType'], null)
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'vehicleSubType'],
        null
      )
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'vehicleType'], null)
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'dataBookCodes'],
        fromJS(null)
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'isPreProduction'],
        false
      ),

  [VEHICLE_AS_BUILT_RECEIVED]: (state, { payload: { serialNumber, data } }) =>
    state
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'loading'], false)
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'features'],
        fromJS(data.features || [])
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'buildDate'],
        data.buildDate || null
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'pto'],
        fromJS(data.pto || null)
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'pneumatics'],
        fromJS(data.pneumatics || null)
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'switchAndGauge'],
        fromJS(data.switchAndGauge || null)
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'dashboardType'],
        data.dashboardType || null
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'vehicleSubType'],
        data.vehicleSubType || null
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'vehicleType'],
        data.vehicleType || null
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'dataBookCodes'],
        fromJS(data.dataBookCodes || null)
      )
      .setIn(
        ['bySerialNumber', serialNumber, 'asBuilt', 'isPreProduction'],
        data.isPreProduction || false
      )
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'error'], null),

  [VEHICLE_AS_BUILT_FAILED]: (state, { payload: { serialNumber, error } }) =>
    state
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'loading'], false)
      .setIn(['bySerialNumber', serialNumber, 'asBuilt', 'error'], error),
}

export default createReducer(initialState, handlers)
